import React from "react";
import PropTypes from "prop-types"
import styled from "@emotion/styled";
import {Motion, spring} from "react-motion";
import {ReactComponent as SelectionRectangle} from "../../assets/SelectionRectangle.svg";


const DrawerSelectorComponentWrapper = styled.div`
  height: 100%;
  width: 92px;
  top: 0;
  left: 0;
  position: absolute;
`;

const SelectionBackGround = styled.div`
  width: 100%;
  height: 100%;
  background: var(--company);
`;


export default function SideDrawerSelectorComponent(props) {

    const {selectorPosition} = props;
    const topOffset = 95;

    let topPosition = (isNaN(selectorPosition)) ? -150 : selectorPosition * topOffset;

    const selectionStyle = {
        position: "absolute",
        right: 0,
    };

    return <DrawerSelectorComponentWrapper>
        <Motion
            defaultStyle={{top: -150}}
            style={{top: spring(topPosition, {stiffness: 170, damping: 26})}}>
            {
                style =>
                    <SelectionRectangle style={
                        {
                            ...selectionStyle,
                            top: style.top
                        }
                    }/>
            }
        </Motion>
        <SelectionBackGround/>
    </DrawerSelectorComponentWrapper>
}

SideDrawerSelectorComponent.propTypes = {
    selectorPosition: PropTypes.number
};
